
import React from 'react';
import PrayerChoiceDialog from './PrayerChoiceDialog';
import AiPrayerAssistantModal from '../ai-assistant/AiPrayerAssistantModal';
import CreatePrayerModal from '../../prayers/CreatePrayerModal';

interface PrayerChoiceControllerProps {
  isOpen: boolean;
  onClose: () => void;
  onINeedPrayer: () => void;
  onIWantToPray: () => void;
  prayerContext?: {
    id: string;
    title: string;
    content: string;
  };
  // New props for managing additional modals
  isAiAssistantOpen?: boolean;
  isCreatePrayerOpen?: boolean;
  onCloseAiAssistant?: () => void;
  onCloseCreatePrayer?: () => void;
}

export default function PrayerChoiceController({
  isOpen,
  onClose,
  onINeedPrayer,
  onIWantToPray,
  prayerContext,
  isAiAssistantOpen = false,
  isCreatePrayerOpen = false,
  onCloseAiAssistant,
  onCloseCreatePrayer
}: PrayerChoiceControllerProps) {
  
  // Add debugging logs
  console.log('PrayerChoiceController render:', {
    isOpen,
    isAiAssistantOpen,
    isCreatePrayerOpen,
    prayerContext: prayerContext?.title || 'none'
  });

  return (
    <>
      {/* Prayer Choice Dialog - Simplified without minimize functionality */}
      {isOpen && (
        <PrayerChoiceDialog
          isOpen={isOpen}
          onClose={onClose}
          onINeedPrayer={onINeedPrayer}
          onIWantToPray={onIWantToPray}
          prayerContext={prayerContext}
        />
      )}
      
      {/* AI Prayer Assistant Modal - Always render when open */}
      {isAiAssistantOpen && onCloseAiAssistant && (
        <>
          {console.log('Rendering AiPrayerAssistantModal')}
          <AiPrayerAssistantModal
            isOpen={isAiAssistantOpen}
            onClose={onCloseAiAssistant}
          />
        </>
      )}
      
      {/* Create Prayer Modal - Always render when open */}
      {isCreatePrayerOpen && onCloseCreatePrayer && (
        <>
          {console.log('Rendering CreatePrayerModal')}
          <CreatePrayerModal
            isOpen={isCreatePrayerOpen}
            onClose={onCloseCreatePrayer}
          />
        </>
      )}
    </>
  );
}
